module.exports = __webpack_public_path__ + "img/GAS.40e9855b.svg";